/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const Liferay = window.Liferay || {
	OAuth2: {
		getAuthorizeURL: () => '',
		getBuiltInRedirectURL: () => '',
		getIntrospectURL: () => '',
		getTokenURL: () => '',
		// eslint-disable-next-line no-unused-vars
		getUserAgentApplication: (_serviceName) => {
			// Intentionally unused parameter
		},
	},
	OAuth2Client: {
		// eslint-disable-next-line no-unused-vars
		FromParameters: (_options) => {
			// Intentionally unused parameter
			return {};
		},
		// eslint-disable-next-line no-unused-vars
		FromUserAgentApplication: (_userAgentApplicationId) => {
			// Intentionally unused parameter
			return {};
		},
		// eslint-disable-next-line no-unused-vars
		fetch: (_url, _options = {}) => {
			// Intentionally unused parameters
		},
	},
	ThemeDisplay: {
		getCompanyGroupId: () => 0,
		getScopeGroupId: () => 0,
		getSiteGroupId: () => 0,
		isSignedIn: () => {
			return false;
		},
	},
	authToken: '',
};